"use client";

import { useState } from "react";
import { toast } from "sonner";
import { useUniversalAuth } from "@west-tennessee-consulting/ui";
import type { GoogleDriveFile } from "./types";

export function useDriveFileDownload(file: GoogleDriveFile | null, isSecondAccount: boolean) {
  const [isDownloading, setIsDownloading] = useState(false);
  const { session } = useUniversalAuth();

  const download = async () => {
    if (!file || isDownloading) return;

    setIsDownloading(true);
    try {
      const params = new URLSearchParams({
        fileId: file.id,
        isSecondAccount: isSecondAccount.toString(),
      });

      const response = await fetch(`/api/unifiedtime/getDrive/download?${params.toString()}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${session?.access_token || ""}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Download failed: ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      toast.success(`Downloaded: ${file.name}`);
    } catch (error: any) {
      console.error("Download error:", error);
      toast.error(`Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, download };
}
